import React, { useContext } from 'react'
import styled, { css } from 'styled-components'

import { AppState } from '../../store/GlobalState'
import { themeValue, BareButton } from '../../ui'
import { useAvailableCirculationMethods } from '../../utils/bundleHelpers.tsx'
//
// Model switcher UI
//
const ModelSwitcherItem = styled(BareButton)`
  color: ${themeValue('colors.always.white')};
  font-weight: ${themeValue('fontWeights.bold')};
  padding: 0 0.2em;
  border-bottom: 2px solid transparent;

  ${(props) =>
    props.active &&
    css`
      border-bottom-color: ${themeValue('colors.always.white')};
    `}

  &:hover,
  &:focus {
    background-color: ${themeValue('colors.primary.highlight')};
  }

  & + & {
    margin-left: ${themeValue('space.tiny')};
  }
`
ModelSwitcherItem.displayName = 'ModelSwitcherItem'

const ModelSwitcherMenu = styled.div`
  background-color: ${themeValue('colors.primary.base')};
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  padding: ${themeValue('space.tiny')};
  border-bottom-left-radius: ${themeValue('borderRadius')};
  border-bottom-right-radius: ${themeValue('borderRadius')};
  z-index: 10;
`
ModelSwitcherMenu.displayName = 'ModelSwitcherMenu'

export const ModelSwitcher = () => {
  const {
    purchaseMethod,
    setPurchaseMethod,
    settings: { vendor, showInstantBundles },
  } = useContext(AppState)

  const modelOptions = useAvailableCirculationMethods(showInstantBundles)

  // if the vendor has only one product type available,
  // this model switcher is not available
  if (!vendor?.productTypes || vendor?.productTypes.length <= 1) {
    return null
  }

  return (
    <div
      style={{
        position: 'relative',
        margin: '0 auto',
      }}>
      <ModelSwitcherMenu>
        {Object.keys(modelOptions).map((option) => (
          <ModelSwitcherItem
            key={modelOptions[option].id}
            active={purchaseMethod === modelOptions[option].id}
            onClick={() => setPurchaseMethod(modelOptions[option].id)}>
            {modelOptions[option].label}
          </ModelSwitcherItem>
        ))}
      </ModelSwitcherMenu>

    </div>
  )
}
